import SectionHomeHero from './SectionHomeHero';

export default SectionHomeHero;
